import { normalizeShippingCountry } from '../dhlPickupPointMap.js'

export function normalizeShippingId(value) {
  const shippingId = Number.parseInt(String(value ?? ''), 10)
  return Number.isInteger(shippingId) && shippingId > 0 ? shippingId : null
}

export function normalizePaymentType(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }
  if (typeof value === 'boolean') {
    return value ? 'cod' : 'nonCod'
  }

  const normalized = String(value).trim().toLowerCase().replace(/[\s_-]/g, '')
  if (['cod', 'cashondelivery', 'cashondeliverypayment'].includes(normalized)) {
    return 'cod'
  }

  return normalized === '' ? null : 'nonCod'
}

export function createCheckoutContext(input = {}) {
  const countryIso = normalizeShippingCountry(input.countryIso ?? input.country)

  return {
    stage: String(input.stage ?? 'other').trim() || 'other',
    cartKey: String(input.cartKey ?? '').trim() || null,
    shippingId: normalizeShippingId(input.shippingId),
    countryIso: countryIso || null,
    paymentType: normalizePaymentType(input.paymentType),
  }
}

export function pointTypeIncludesShippingId(shippingIds, shippingId) {
  const normalizedShippingId = normalizeShippingId(shippingId)
  return normalizedShippingId !== null
    && Array.isArray(shippingIds)
    && shippingIds.some((value) => normalizeShippingId(value) === normalizedShippingId)
}

export function isPickupShipping(settings, shippingId) {
  if (pointTypeIncludesShippingId(settings?.pickup, shippingId)) {
    return true
  }

  const pointTypes = settings?.pointType
  return pointTypeIncludesShippingId(pointTypes?.parcelShop, shippingId)
    || pointTypeIncludesShippingId(pointTypes?.packStation, shippingId)
}

export function pickupPointTypeForShipping(settings, shippingId) {
  const pointTypes = settings?.pointType

  if (pointTypeIncludesShippingId(pointTypes?.packStation, shippingId)) {
    return 'packStation'
  }
  if (pointTypeIncludesShippingId(pointTypes?.parcelShop, shippingId)) {
    return 'parcelShop'
  }

  return null
}

export function checkoutContextFingerprint(context) {
  const normalized = createCheckoutContext(context)
  return JSON.stringify([
    normalized.cartKey,
    normalized.shippingId,
    normalized.countryIso,
    normalized.paymentType,
  ])
}

export function sameCheckoutContext(left, right) {
  return checkoutContextFingerprint(left) === checkoutContextFingerprint(right)
}

export function getContextInvalidationReason(previous, current) {
  const before = createCheckoutContext(previous)
  const after = createCheckoutContext(current)

  if (before.cartKey && after.cartKey && before.cartKey !== after.cartKey) {
    return 'cart'
  }
  if (before.shippingId !== null && after.shippingId !== null && before.shippingId !== after.shippingId) {
    return 'shipping'
  }
  if (before.countryIso && after.countryIso && before.countryIso !== after.countryIso) {
    return 'country'
  }
  if (before.paymentType === 'nonCod' && after.paymentType === 'cod') {
    return 'payment'
  }

  return null
}

export function shouldInvalidateSelection(previous, current) {
  return getContextInvalidationReason(previous, current) !== null
}
